import { ShoppingCartThemeSizeConfig } from './types';

const large: ShoppingCartThemeSizeConfig = {
  shoppingCart: {},
};

export default large;
